// extracted by mini-css-extract-plugin
export default {"container":"PageTitle_container__lFKvY","title":"PageTitle_title__uqQWO","subtitle":"PageTitle_subtitle__cY1D2","separator":"PageTitle_separator__+b+GL"};